module.exports = __webpack_public_path__ + "static/img/img34.d550964.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img34.jpg
// module id = Vgi3
// module chunks = 1